<!-- <app-loader *ngIf="showSpinner"> </app-loader> -->
<div class="main-common-wrapper">
  <div class="inner-comon-wrapper">
    <div class="main-announcement border">
      <div class="inner-announcement left-announcement-sec">
        <div class="main-header-left">

          <div class="left-announcement-header">
            <h5>
              Announcement
            </h5>

            <div class="toggle-button" (click)="toggleView()">
              <div [class.active-toggle]="isListView" class="toggle-single-button">
                <!-- List View Icon -->
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                    [attr.stroke]="isListView ? '#00989B' : '#555555'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  </svg>
                </div>

                <div [class.active-toggle]="!isListView" class="toggle-single-button">
                  <!-- Updated Category View Icon -->
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6 1.5H2.83333C2.36662 1.5 2.13327 1.5 1.95501 1.59083C1.79821 1.67072 1.67072 1.79821 1.59083 1.95501C1.5 2.13327 1.5 2.36662 1.5 2.83333V6C1.5 6.46671 1.5 6.70007 1.59083 6.87833C1.67072 7.03513 1.79821 7.16261 1.95501 7.24251C2.13327 7.33333 2.36662 7.33333 2.83333 7.33333H6"
                      [attr.stroke]="!isListView ? '#00989B' : '#555555'" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                      <path
                        d="M15.1667 1.5H12C11.5333 1.5 11.2999 1.5 11.1217 1.59083C10.9649 1.67072 10.8374 1.79821 10.7575 1.95501C10.6667 2.13327 10.6667 2.36662 10.6667 2.83333V6C10.6667 6.46671 10.6667 6.70007 10.7575 6.87833C10.8374 7.03513 10.9649 7.16261 11.1217 7.24251C11.2999 7.33333 11.5333 7.33333 12 7.33333H15.1667"
                        [attr.stroke]="!isListView ? '#00989B' : '#555555'" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                        <path
                          d="M15.1667 10.6667H12C11.5333 10.6667 11.2999 10.6667 11.1217 10.7575C10.9649 10.8374 10.8374 10.9649 10.7575 11.1217C10.6667 11.2999 10.6667 11.5333 10.6667 12V15.1667C10.6667 15.6334 10.6667 15.8667 10.7575 16.045C10.8374 16.2018 10.9649 16.3293 11.1217 16.4092C11.2999 16.5 11.5333 16.5 12 16.5H15.1667"
                          [attr.stroke]="!isListView ? '#00989B' : '#555555'" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                          <path
                            d="M6 10.6667H2.83333C2.36662 10.6667 2.13327 10.6667 1.95501 10.7575C1.79821 10.8374 1.67072 10.9649 1.59083 11.1217C1.5 11.2999 1.5 11.5333 1.5 12V15.1667C1.5 15.6334 1.5 15.8667 1.59083 16.045C1.67072 16.2018 1.79821 16.3293 1.95501 16.4092C2.13327 16.5 2.36662 16.5 2.83333 16.5H6"
                            [attr.stroke]="!isListView ? '#00989B' : '#555555'" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          </svg>
                        </div>

                      </div>

                    </div>
                    <div class="tabs-header-main">
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button class="nav-link active" id="nav-all-tab" data-bs-toggle="tab" data-bs-target="#nav-all"
                        type="button" role="tab" aria-controls="nav-all" aria-selected="true">All</button>
                        <button class="nav-link" id="nav-active-tab" data-bs-toggle="tab" data-bs-target="#nav-active"
                        type="button" role="tab" aria-controls="nav-active" aria-selected="false">Active</button>
                        <button class="nav-link" id="nav-event-tab" data-bs-toggle="tab" data-bs-target="#nav-event" type="button"
                        role="tab" aria-controls="nav-event" aria-selected="false">Events</button>
                        <button class="nav-link" id="nav-boarding-tab" data-bs-toggle="tab" data-bs-target="#nav-boarding"
                        type="button" role="tab" aria-controls="nav-boarding" aria-selected="false">Onboarding</button>
                        <button class="nav-link" id="nav-celebration-tab" data-bs-toggle="tab" data-bs-target="#nav-celebration"
                        type="button" role="tab" aria-controls="nav-celebration" aria-selected="false">Celebration</button>

                      </div>
                    </div>
                  </div>

                  @if (isListView) {
                    <div class="left-annoucement-body">
                      <div class="tabs-body-main">
                        <div class="tab-content" id="nav-tabContent">
                          <div class="tab-pane fade active show" id="nav-all" role="tabpanel" aria-labelledby="nav-all-tab">
                            <div class="tab-body">
                              <div class="tab-body-header">
                                <div class="header-right">
                                  <div class="header-img">
                                    <img src="../../../assets/images/fake-profile.jpg">
                                  </div>
                                  <div class="header-detail">
                                    <h1>Shafaq Jawad</h1>
                                    <p>HR Manager</p>
                                  </div>
                                </div>
                                <div class="header-left">
                                  <p>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M14 6.66732H2M10.6667 1.33398V4.00065M5.33333 1.33398V4.00065M5.2 14.6673H10.8C11.9201 14.6673 12.4802 14.6673 12.908 14.4493C13.2843 14.2576 13.5903 13.9516 13.782 13.5753C14 13.1475 14 12.5874 14 11.4673V5.86732C14 4.74721 14 4.18716 13.782 3.75934C13.5903 3.38301 13.2843 3.07705 12.908 2.8853C12.4802 2.66732 11.9201 2.66732 10.8 2.66732H5.2C4.0799 2.66732 3.51984 2.66732 3.09202 2.8853C2.71569 3.07705 2.40973 3.38301 2.21799 3.75934C2 4.18716 2 4.74721 2 5.86732V11.4673C2 12.5874 2 13.1475 2.21799 13.5753C2.40973 13.9516 2.71569 14.2576 3.09202 14.4493C3.51984 14.6673 4.0799 14.6673 5.2 14.6673Z"
                                        stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>
                                      21 Aug 2021
                                      <span class="expire-span">Expired</span>
                                    </p>
                                  </div>
                                </div>
                                <div class="tab-body-image">
                                  <img src="../../../assets/theme1/gallery1.png" alt="missing image">
                                </div>
                                <div class="tab-body-footer">
                                  <h1>Bank Account Opening</h1>
                                  <p>This is to inform you that please send me the bank details who get it. And if any one left come
                                    to HR i will provide bank letter to open an account. This month salary will be only transfer in
                                    Mezan bank accounts and not by cash simply it would be hold before the end of month every one
                                    should have account in meezan bank.
                                  Thank You.</p>
                                </div>
                              </div>
                              <div class="tab-body mt-4">
                                <div class="tab-body-header">
                                  <div class="header-right">
                                    <div class="header-img">
                                      <img src="../../../assets/images/fake-profile.jpg">
                                    </div>
                                    <div class="header-detail">
                                      <h1>Shafaq Jawad</h1>
                                      <p>HR Manager</p>
                                    </div>
                                  </div>
                                  <div class="header-left">
                                    <p>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M14 6.66732H2M10.6667 1.33398V4.00065M5.33333 1.33398V4.00065M5.2 14.6673H10.8C11.9201 14.6673 12.4802 14.6673 12.908 14.4493C13.2843 14.2576 13.5903 13.9516 13.782 13.5753C14 13.1475 14 12.5874 14 11.4673V5.86732C14 4.74721 14 4.18716 13.782 3.75934C13.5903 3.38301 13.2843 3.07705 12.908 2.8853C12.4802 2.66732 11.9201 2.66732 10.8 2.66732H5.2C4.0799 2.66732 3.51984 2.66732 3.09202 2.8853C2.71569 3.07705 2.40973 3.38301 2.21799 3.75934C2 4.18716 2 4.74721 2 5.86732V11.4673C2 12.5874 2 13.1475 2.21799 13.5753C2.40973 13.9516 2.71569 14.2576 3.09202 14.4493C3.51984 14.6673 4.0799 14.6673 5.2 14.6673Z"
                                          stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        21 Aug 2021
                                        <span class="active-span">Active</span>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- <div class="tab-body-image">
                                  <img src="../../../assets/theme1/gallery1.png" alt="missing image">
                                </div> -->
                                <div class="tab-body-footer">
                                  <h1>Bank Account Opening</h1>
                                  <p>This is to inform you that please send me the bank details who get it. And if any one left come
                                    to HR i will provide bank letter to open an account. This month salary will be only transfer in
                                    Mezan bank accounts and not by cash simply it would be hold before the end of month every one
                                    should have account in meezan bank.
                                  Thank You.</p>
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane fade" id="nav-active" role="tabpanel" aria-labelledby="nav-active-tab">
                              <div class="notify-content-main ">
                              </div>
                            </div>
                            <div class="tab-pane fade" id="nav-event" role="tabpanel" aria-labelledby="nav-event-tab">
                              <div class="notify-content-main ">
                              </div>
                            </div>
                            <div class="tab-pane fade" id="nav-boarding" role="tabpanel" aria-labelledby="nav-boarding-tab">
                              <div class="notify-content-main ">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  @if (isListView) {
                    <div class="inner-announcement right-announcement-sec">
                      <div class="right-announcement-header">
                        <div class="filter-image">
                          <img src="../../../assets/theme1/filter.png" alt="missing icon">
                        </div>
                        <h1>Set Filters Here</h1>
                      </div>
                      <form>
                        <div class="filter-announment-body">
                          <div class="filter-body-head">
                            <h1>
                              Filters
                              <span>Please fill the Information to Apply the Filter</span>
                            </h1>
                            <div class="reset-button">
                              Reset all
                            </div>
                          </div>
                          <div class="filter-body-form">
                            <div class="common-fields">
                              <label>Category</label>
                              <div class="form-group">
                                <input type="text" name="category" placeholder="Search Category" />
                                <img class="search-icon" src="../../../assets/theme1/search-icon.png" alt="Missing icon">
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  }


                </div>
              </div>
            </div>